import Axois from '../utils/axios'
import EventEmitter from "../../utils/eventEmitter";



export const loadProductPackagings = async () => {
  let response = await Axois.get('/product-packagings').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadProductPackaging = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/product-packagings');
        const responseData = await requests.data;
        return {...responseData, productPackage: {}};
        // return { positions: [], budgets: [], analytic: {}};
      
      default:
        let response = await Axois.get('/product-packagings/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return { positions: [], budgets: [], analytic: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const useProductPackagingAPI = () => {
  
  const create = async (data, success) => {
    try {
      const response = await Axois.post('/product-packagings', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('product_packaging_created', data.seo);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/product-packagings/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('product_packaging_updated', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { create, update };
}


export default useProductPackagingAPI;